import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, GraduationCap, Handshake, Globe2, Award } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const OBJECTIVES = [{
  icon: GraduationCap,
  title: 'Financiamiento',
  text: 'Recaudar fondos para becas oficiales y evaluaciones especializadas para familias con pocos recursos'
}, {
  icon: Handshake,
  title: 'Alianzas',
  text: 'Fortalecer programas existentes y crear nuevas alianzas estratégicas con empresas y profesionales'
}, {
  icon: Globe2,
  title: 'Impacto Social',
  text: 'Sensibilizar a la comunidad y construir una red sostenible alrededor de la neurodiversidad'
}];
interface Package {
  name: string;
  borderColor: string;
  featured?: boolean;
  benefits: string[];
}
const PACKAGES: Package[] = [{
  name: 'Patrocinador Oro',
  borderColor: '#f59e0b',
  featured: true,
  benefits: ['Logo en material impreso', 'Logo en pantallas del evento', '4 publicaciones en redes', 'Presencia en página web', 'Espacio para exhibición', '4 entradas VIP', 'Reconocimiento en evento', 'Comunicados de prensa', 'Certificado de patrocinio', 'Reporte de impacto anual']
}, {
  name: 'Patrocinador Plata',
  borderColor: '#94a3b8',
  benefits: ['Logo en material impreso', 'Logo en pantallas del evento', '2 publicaciones en redes', 'Presencia en página web', '2 entradas VIP', 'Reconocimiento en evento', 'Certificado de patrocinio']
}, {
  name: 'Patrocinador Bronce',
  borderColor: '#cd7f32',
  benefits: ['Logo en pantallas del evento', '1 publicación en redes', 'Presencia en página web', '1 entrada VIP', 'Certificado de patrocinio']
}];
export function Gala2026() {
  useDocumentMeta({
    title: 'Gala 2026 | Pancita Feliz Foundation',
    description: 'Gala Fundación Pancita Feliz 2026 — 22 de agosto de 2026 en el Doral Cultural Art Center, con el respaldo de la Ciudad de Doral.',
    path: '/gala-2026'
  });
  return <main className="w-full" data-id="element-379" data-mp="f8kzr7f3w48q">
      {/* Hero */}
      <section className="mp-gala-hero text-center" style={{
      background: 'linear-gradient(135deg, #0d1f07 0%, #1a3a0a 50%, #0f2d05 100%)',
      padding: '100px 20px 80px'
    }} data-id="element-380" data-mp="f7t2ls5v1ygc">
        <p style={{
        color: '#a8e063',
        fontSize: '11px',
        letterSpacing: '3px',
        fontWeight: 700,
        marginBottom: '12px'
      }} data-id="element-381" data-mp="p0qo8765g3j6">
          PRIMER EVENTO ANUAL
        </p>
        <h1 className="mp-gala-title" style={{
        fontSize: '52px',
        fontWeight: 900,
        color: 'white',
        marginBottom: '20px',
        lineHeight: 1.05
      }} data-id="element-382" data-mp="12x481my5oh0t">
          Gala Fundación Pancita Feliz 2026
        </h1>
        <div className="mp-gala-badge" style={{
        background: 'rgba(255,255,255,0.1)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '30px',
        padding: '10px 24px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '24px',
        color: 'white',
        fontSize: '14px',
        fontWeight: 600
      }} data-id="element-383" data-mp="2x72ldo7le27o">
          <span className="inline-flex items-center gap-2" data-id="element-384" data-mp="3b5923rketlk4">
            <Calendar size={16} color="#a8e063" data-id="element-385" data-mp="3b3ph5nnt6mc0" />
            22 de agosto de 2026
          </span>
          <span aria-hidden="true" data-id="element-386" data-mp="368scesxkaz4x">·</span>
          <span className="inline-flex items-center gap-2" data-id="element-387" data-mp="318e377k85j5b">
            <MapPin size={16} color="#a8e063" data-id="element-388" data-mp="319yxcw2mn02n" />
            Doral Cultural Art Center
          </span>
        </div>
        <p style={{
        fontSize: '18px',
        color: 'rgba(255,255,255,0.8)',
        maxWidth: '600px',
        margin: '0 auto 24px'
      }} data-id="element-389" data-mp="1psfrevxnwj0e">
          Nuestro primer gran evento anual de recaudación de fondos, con el
          respaldo de la Ciudad de Doral
        </p>
        <p style={{
        background: 'rgba(125,201,32,0.15)',
        border: '1px solid rgba(125,201,32,0.4)',
        borderRadius: '20px',
        padding: '8px 20px',
        display: 'inline-block',
        color: '#a8e063',
        fontSize: '13px',
        fontWeight: 600
      }} data-id="element-390" data-mp="34p8k2h2jpnjk">
          Con el respaldo de la Ciudad de Doral
        </p>
        <div data-id="element-391" data-mp="3ndx28v9n9ern">
          <Link to="/quiero-ser-aliado" className="mp-gala-cta" style={{
          background: '#7DC920',
          color: 'white',
          padding: '16px 40px',
          borderRadius: '12px',
          fontWeight: 700,
          fontSize: '16px',
          marginTop: '32px',
          display: 'inline-block',
          textDecoration: 'none'
        }} data-id="element-392" data-mp="3ne5fwpdlco3w">
            Quiero ser Patrocinador
          </Link>
        </div>
      </section>

      {/* Objectives */}
      <section className="mp-gala-section" style={{
      background: '#f9fdf5',
      padding: '80px 20px'
    }} data-id="element-393" data-mp="181o7wasy902d">
        <h2 className="mp-gala-h2" style={{
        textAlign: 'center',
        fontSize: '36px',
        fontWeight: 800,
        color: '#1a1a1a',
        marginBottom: '48px'
      }} data-id="element-394" data-mp="140uifczuzd7d">
          Objetivos del Evento
        </h2>
        <div className="mp-gala-objectives" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '24px',
        maxWidth: '960px',
        margin: '0 auto'
      }} data-id="element-395" data-mp="p3vebz47u2hn">
          {OBJECTIVES.map(({
          icon: Icon,
          title,
          text
        }) => <div key={title} style={{
          background: 'white',
          borderRadius: '16px',
          padding: '32px 24px',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
          borderTop: '4px solid #7DC920'
        }} data-id="element-396" data-mp="3ooh9lcmvthyi">
              <Icon size={36} color="#7DC920" className="mx-auto" style={{
            marginBottom: '16px'
          }} data-id="element-397" data-mp="26f3icerm597j" />
              <h3 style={{
            fontSize: '20px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '10px'
          }} data-id="element-398" data-mp="1dqxuvk96d640">
                {title}
              </h3>
              <p style={{
            fontSize: '14px',
            color: '#666',
            lineHeight: 1.6
          }} data-id="element-399" data-mp="2u4xt8qsdgnp5">
                {text}
              </p>
            </div>)}
        </div>
      </section>

      {/* Sponsorship packages */}
      <section className="mp-gala-section" style={{
      background: 'white',
      padding: '80px 20px'
    }} data-id="element-400" data-mp="igsyr8b2l2ek">
        <h2 className="mp-gala-h2" style={{
        textAlign: 'center',
        fontSize: '36px',
        fontWeight: 800,
        color: '#1a1a1a',
        marginBottom: '12px'
      }} data-id="element-401" data-mp="do9nwj3roldg">
          Paquetes de Patrocinio
        </h2>
        <p style={{
        textAlign: 'center',
        color: '#666',
        marginBottom: '48px'
      }} data-id="element-402" data-mp="3vuo0adme0n9q">
          Invierte en el futuro de familias con niños neurodiversos
        </p>
        <div className="mp-gala-packages" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '24px',
        maxWidth: '1000px',
        margin: '0 auto'
      }} data-id="element-403" data-mp="1p5hmuovn99a8">
          {PACKAGES.map(pkg => <div key={pkg.name} style={{
          border: `2px solid ${pkg.borderColor}`,
          borderRadius: '20px',
          padding: '36px 28px',
          textAlign: 'center',
          background: 'white',
          position: 'relative'
        }} data-id="element-404" data-mp="y05kuw9miqig">
              {pkg.featured && <span style={{
            position: 'absolute',
            top: '-12px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#f59e0b',
            color: 'white',
            fontSize: '11px',
            fontWeight: 700,
            padding: '4px 14px',
            borderRadius: '20px',
            whiteSpace: 'nowrap'
          }} data-id="element-405" data-mp="acno0mbi528m">
                  MÁS COMPLETO
                </span>}
              <h3 style={{
            fontSize: '20px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-406" data-mp="3k5gyuysc7zsk">
                {pkg.name}
              </h3>
              <ul style={{
            textAlign: 'left',
            marginTop: '20px'
          }} data-id="element-407" data-mp="3p5uxjq81txdx">
                {pkg.benefits.map(benefit => <li key={benefit} style={{
              fontSize: '14px',
              color: '#444',
              padding: '6px 0',
              borderBottom: '1px solid #f5f5f5',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }} data-id="element-408" data-mp="2qijfcij8syt">
                    <span aria-hidden="true" style={{
                color: '#7DC920',
                fontWeight: 700
              }} data-id="element-409" data-mp="2dl7mmqhsogjy">
                      ✓
                    </span>
                    {benefit}
                  </li>)}
              </ul>
            </div>)}
        </div>
        <a href="https://payhip.com/b/PCzmW" target="_blank" rel="noopener noreferrer" className="mp-gala-download" style={{
        background: 'transparent',
        color: '#2d5a1b',
        border: '2px solid #2d5a1b',
        padding: '14px 32px',
        borderRadius: '10px',
        fontWeight: 600,
        display: 'block',
        width: 'fit-content',
        margin: '32px auto 0',
        textDecoration: 'none'
      }} data-id="element-410" data-mp="czf6gcdrl0r">
          Descargar propuesta completa (PDF) →
        </a>
      </section>

      {/* City endorsement */}
      <section style={{
      background: '#f0fae8',
      padding: '60px 20px',
      textAlign: 'center'
    }} data-id="element-411" data-mp="2to6ic50a6yo0">
        <Award size={48} color="#2d5a1b" className="mx-auto" style={{
        marginBottom: '16px'
      }} data-id="element-412" data-mp="2yom0d9vicucb" />
        <h2 style={{
        fontSize: '28px',
        fontWeight: 800,
        color: '#1a1a1a',
        marginBottom: '12px'
      }} data-id="element-413" data-mp="37nz7vx02n8ue">
          Con el Respaldo de la Ciudad de Doral
        </h2>
        <p style={{
        maxWidth: '600px',
        margin: '0 auto',
        fontSize: '16px',
        color: '#444',
        lineHeight: 1.7
      }} data-id="element-414" data-mp="3hj0zczhtkn05">
          Este evento cuenta con el apoyo del gobierno de la Ciudad de Doral, a
          través del Concejal Rafael Pineyro, como parte del compromiso de la
          ciudad con el bienestar infantil y la inclusión.
        </p>
        <p style={{
        fontSize: '11px',
        color: '#999',
        marginTop: '12px'
      }} data-id="element-415" data-mp="2092mep2uxo7e">
          * Texto sujeto a validación con el equipo del Concejal Pineyro
        </p>
      </section>

      {/* Final CTA */}
      <section style={{
      background: '#2d5a1b',
      padding: '60px 20px',
      textAlign: 'center'
    }} data-id="element-416" data-mp="2a18cft9jtvjy">
        <h2 className="mp-gala-h2" style={{
        fontSize: '36px',
        fontWeight: 800,
        color: 'white',
        marginBottom: '16px'
      }} data-id="element-417" data-mp="2iz25mvc0o92w">
          ¿Tu empresa quiere ser parte de esto?
        </h2>
        <p style={{
        color: 'rgba(255,255,255,0.8)',
        marginBottom: '32px'
      }} data-id="element-418" data-mp="2nzg35jfzs0mo">
          Quedan pocos paquetes de patrocinio disponibles
        </p>
        <Link to="/quiero-ser-aliado" className="mp-gala-cta" style={{
        background: '#7DC920',
        color: 'white',
        padding: '16px 48px',
        borderRadius: '12px',
        fontWeight: 700,
        fontSize: '18px',
        display: 'inline-block',
        textDecoration: 'none'
      }} data-id="element-419" data-mp="tlf4ozoctfn4">
          Quiero ser Patrocinador
        </Link>
      </section>
    </main>;
}